module.exports = __webpack_public_path__ + "static/media/1.df4005e7.png";